<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" >
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('invoices.invoices_issuing.step0.modal_header') }}</h2>
        </div>
        <span class="cursor-pointer" @click="setIssuer(true)">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="flex flex-row justify-center content-center h-16">
        <span class="text-center w-full content-center dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="setIssuer(true)" mode="secondary-phantom-blue" :text="$t('app.cancel')" :loading="isGeneralLoading" />
        <base-button mode="secondary-phantom-blue" class="w-full mx-2" :text="$t('invoices.invoices_issuing.step0.modal_continue')" @click="setIssuer(false)" :loading="isGeneralLoading"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>

import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'reset-dialog',
  components: {
    // DetailLayout,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      searchView: false,
      isOpen: this.dialogOpen,
      activeName: 'es',
      processMessage: i18n.t('invoices.invoices_issuing.step0.modal_message'),
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    }
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value !== oldValue) {
        this.isOpen = !this.isOpen
      }
    },
  },
  mounted: async function () {
  },
  methods: {
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    setIssuer: function (cancel = false) {
      this.$emit('applyDialog', cancel)
      this.toggleDialog()
    }


  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}

</style>
